import { render, staticRenderFns } from "./NotifCommentPostIBookmarked.vue?vue&type=template&id=1d219419&scoped=true"
import script from "./NotifCommentPostIBookmarked.vue?vue&type=script&lang=js"
export * from "./NotifCommentPostIBookmarked.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=1d219419&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d219419",
  null
  
)

export default component.exports